import { DataService } from "../../../../Autofacets-Core/src/app/services/data.service";
import { Injectable } from "@angular/core";
import { GenericResponse } from "../../../../Autofacets-Core/src/app/business-entities/generic-response.class";
import { Urls } from "../../../../Autofacets-Core/src/app/utils/urls";
import { ContactUserListRequestModel } from "../business-entities/contact-user-details-view-model";

@Injectable({
    providedIn: 'root'
})
export class ContactUserDataService {
    constructor(private dataProvider: DataService) {
    }
async getContactUserList(requestModel: ContactUserListRequestModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetContactUserList, requestModel).toPromise();
    }
}